import $ from 'jquery';

export function initGrantSelectPanel() {
    $('.js-main-filter').on('change', (event: JQuery.ChangeEvent) => {
        var key = $(event.target).val().toLowerCase();
        var secondary = $(event.target).attr('data-filter');
        if (secondary) {
            var sec = $('.' + secondary);

            $('.' + secondary + ' option').each(function (data, ele) {
                if ($(ele).attr('data-key') != key && $(ele).attr('data-key') != 'no-option') {
                    ele.style.display = 'none';
                } else {
                    ele.style.display = 'block';
                }
            });

            sec.removeAttr('disabled');
            sec.val('no-option');
        }
    });
    $('.js-secondary-filter').on('change', (event: JQuery.ChangeEvent) => {
        var key = $(event.target).val().toLowerCase();
        var submit = $(event.target).attr('data-filter');
        if (key != '') {
            $('.' + submit).removeAttr('disabled');
        } else {
            $('.' + submit).attr('disabled');
        }
    });
    $('.js-submit-filter').on('click', (event: JQuery.ClickEvent) => {
        var secondary = $(event.target).attr('data-filter');
        if (secondary) {
            var val = $('.' + secondary).val();
            if (val != null) {
                var url =
                    '/' +
                    val
                        .toString()
                        .replace(/_/g, '/')
                        .replace(/&?select\d=/g, '/');
                location.href = url;
            }
        }
    });
}
